import React, { useEffect, useState } from "react";
import "./../component_styles/Testimonials.css";

const Testimonials = () => {
  const reviews = [
    {
      name: "Hoda Said",
      quote:
        "Marianna is very knowledgeable, caring, accurate, honest and friendly to deal with. I really enjoyed a good peace of mind after I transferred my medications to Thompson Square Pharmacy.",
      image: "./assets/hoda-dp.png",
    },
    {
      name: "Saeed ur Rehman",
      quote:
        "Great service by Mariana. Quick processing and accurate advice. Always have required medicines in their stock. This is our first choice to go in Milton",
      image: "./assets/saeed-dp.png",
    },
    {
      name: "Marianne Mofeed",
      quote:
        "They say a good pharmacy fills your prescriptions, but a great one fills your heart. Thompson Square Pharmacy does both, and so much more. They're a shining example of how patient-centered care should be done, and I couldn't recommend them more highly. If you're looking for a pharmacy that truly cares about your well-being, look no further than Thompson Square. You won't just find medications, you'll find a family.",
      image: "./assets/marianne-dp.png",
    },
  ];

  return (
    <section className="testimonials-section">
      <div className="testimonials-header">
        <h2>
          Our customers <span className="text-[#f49988]">love</span> our
          service:
        </h2>
        <p>Here's what they have to say</p>
      </div>

      <div className="testimonials-container">
        {reviews.length > 0 ? (
          reviews.map((review, index) => (
            <div key={index} className="testimonial-card">
              <div className="testimonial-image-container">
                <img
                  src={`${review.image}`}
                  alt={review.name}
                  className="testimonial-image"
                />
                <div className="quote-icon">“</div>
              </div>

              <p className="testimonial-quote">“{review.quote}”</p>
              <h3 className="testimonial-name">{review.name}</h3>
              <p className="testimonial-position">⭐ 5 Stars</p>
            </div>
          ))
        ) : (
          <p>Loading reviews...</p>
        )}
      </div>
    </section>
  );
};

export default Testimonials;
